module.exports = __webpack_public_path__ + "img/icon_add.9eadee98.png";